import React from "react";
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import { SourceFlowHead } from "@sourceflow-uk/sourceflow-head";
import metaObject from "@/.sourceflow/metadata.json";
import sourceflowEnums from "@/sourceflow.enums";
import SubBanner from "@/components/SubBanner";
import FooterWave from "@/public/site-assets/svg/footer-wave.svg";
import SimpleFormWithColumn from "@/components/SimpleFormWithColumn";
import TextWithOffices from "components/TextWithOffices";

import {
    Container,
} from 'reactstrap';

import { router } from "@/routes";
import { useLocale } from "@/hooks/useLocale";
/**
 *
 * @param global
 * @param meta
 * @returns {JSX.Element}
 * @constructor
 */
export default function ContactUsPage({
    global,
    meta,
    locations
}) {
    const locale = useLocale();

    return (
        <>
            <SourceFlowHead
                metaObject={metaObject}
                title={meta.title}
                description={meta.description}
                canonical={meta.canonical}
            />
            <SubBanner
                global={global}
                pathPrefix={`contact_us.location.page.sub_banner`}
                heading={`Contact Us`}
                content={<p>Amet eget a mauris quis dignissim lacus lectus nec. Suspendisse facilisis ipsum fermentum viverra tincidunt viverra felis vulputate amet.</p>}
                breadcrumb_title={<><span className="active">Contact Us</span></>}
                wave_color={``}
            />
            <section className="bg-white">
                <SimpleFormWithColumn
                    global={global}
                    pathPrefix={`contact_us.location.page.simple_form_with_column`}
                    heading={``}
                    content={
                        <>
                            <h2>Get in touch</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut </p>
                        </>
                    }
                    formId={`${sourceflowEnums.forms.contact_us}`}
                    imageURL={``}
                    page_slug={`contact-us`}
                    social_share={true}
                    share_heading={`Contact us today:`}
                />
            </section>
            {/* <TextWithOffices
                global={global}
                pathPrefix={`contact_us.location.page.text_with_offices`}
                heading={`Our Offices`}
                content={
                    <>
                        <p>Tradewind Subs have 13 offices across the UK. Our reach may be national, but our focus is local. Our consultants have first-hand knowledge of the areas they work in and will always aim to use that insight to help you find your ideal candidate.</p>
                    </>
                }
                post={locations}
                heading_tag={`h3`}
                className="contact-us-page pb-5"
            /> */}
        </>
    );
}

/**
 *
 * @returns {Promise<{props: {meta: {description: string, canonical: string, title: string}, jobs: *, global}}>}
 */
export async function getStaticProps() {
    const global = (await Global()).toJson();
    const locations = (await Collection(`locations`)).getItems()

    const routerKey = "contact_us";

    return {
        props: {
            global,
            locations,
            meta: {
                title: `Contact Us | Tradewind Subs`,
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            }
        },
    };
}
